// @flow
import { v4 as uuidv4 } from 'uuid';
import type { itemsType } from '@shared/model/constant/itemsType';

function normalizeForSelect(
	list: Array<any> = [],
	{ title, value, id = '' }: itemsType = {},
): Array<Object> {
	console.log({list})
	return list?.map((item) => ({
		id: item[id] || uuidv4(),
		title: item[title] || item,
		value: item[value] ?? item,
	}));
}

export default normalizeForSelect;
